import { createGlobalStyle } from 'styled-components';

import './fonts.css';
import './Colors/color-variables.css';
import './app-variables.css';
import './theme-colors.css';
import legacyColors from './Colors/legacy-colors';
import themeSelectors from './theme-selectors';

export default createGlobalStyle`
  ${legacyColors}
  ${themeSelectors}

  body {
    margin: 0;
    font-family: var(--app-font), sans-serif;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

  }

  /* Form controls do not inherit font-family from body, so the one rule above would miss them.
     With this, every element either inherits or is covered, and components need no declaration. */
  input, button, select, textarea, optgroup {
    font-family: inherit;
  }

  ul, ol {
    margin: 5px;
    padding-left: 15px;
  }

  * {
        /* width */
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: var(--scrollbar-track-bg);
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: var(--scrollbar-thumb-bg);
      border-radius: var(--scrollbar-thumb-b-radius);
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    }

    ::-webkit-scrollbar-corner {
      background-color: transparent;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }
`;
